
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

type SortOption = "newest" | "oldest" | "most_viewed" | "title_asc" | "title_desc";

const SORT_OPTIONS: { label: string; value: SortOption }[] = [
  { label: "Newest First", value: "newest" },
  { label: "Oldest First", value: "oldest" },
  { label: "Most Viewed", value: "most_viewed" },
  { label: "Title (A-Z)", value: "title_asc" },
  { label: "Title (Z-A)", value: "title_desc" },
];

interface LibraryControlsProps {
  viewMode: "recipes" | "creators";
  setViewMode: (value: "recipes" | "creators") => void;
  sortBy: SortOption;
  setSortBy: (value: SortOption) => void;
}

export const LibraryControls = ({
  viewMode,
  setViewMode,
  sortBy,
  setSortBy,
}: LibraryControlsProps) => {
  return (
    <div className="flex items-center gap-4">
      <ToggleGroup
        type="single"
        value={viewMode}
        onValueChange={(value) => {
          if (value) setViewMode(value as "recipes" | "creators");
        }}
        className="border rounded-lg"
      >
        <ToggleGroupItem value="recipes" aria-label="View Recipes" className="px-4 py-2">
          Recipes
        </ToggleGroupItem>
        <ToggleGroupItem value="creators" aria-label="View Creators" className="px-4 py-2">
          Creators
        </ToggleGroupItem>
      </ToggleGroup>

      <Select value={sortBy} onValueChange={(value) => setSortBy(value as SortOption)}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Sort by..." />
        </SelectTrigger>
        <SelectContent>
          {SORT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
